var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"index-notice"}},[_c('NoticeList',{attrs:{"editPageble":0,"pageNo":1,"pageSize":20}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }